/*
 * base on clientWidth,then transform to rem,default 375px == 20rem
 *
 * this way in lifecycle 'mounted' in App.vue is ok
 */

export function setRem (doc, win) {
  const docEl = doc.documentElement
  let resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize'
  let reCaculate = function () {
    let clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (clientWidth > 768) {
      // docEl.style.fontSize = 40 + 'px'
      // document.getElementById('app').style.width = 768 + 'px'
      // doc.documentElement.style.width = 768 + 'px'
      // doc.documentElement.style.marginTop = 0
      // doc.documentElement.style.marginBottom = 0
      // doc.documentElement.style.marginLeft = 'auto'
      // doc.documentElement.style.marginRight = 'auto'
    } else {
      // docEl.style.fontSize = 20 * (clientWidth / 375) + 'px'
      const fz = 20 * (clientWidth / 375)
      docEl.style.fontSize = fz + 'px'
      // 解决手机系统字体过大的影响
      const realFz = +window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize.replace('px', '')
      if (realFz !== fz) {
        docEl.style.fontSize = fz * (fz / realFz) + 'px'
      }
    }
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvent, reCaculate, false)
  doc.addEventListener('DOMContentLoaded', reCaculate, false)
}
